import { graphql } from '@/gql';
import type { ScheduledDeliveryUpdateInput } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateScheduledDelivery = async (schedule: ScheduledDeliveryUpdateInput) => {
  const response = await mutationExecute({
    variables: {
      schedule,
    },
    mutation: graphql(`
      mutation UpdateScheduledDelivery($schedule: ScheduledDeliveryUpdateInput!) {
        updateSchedule(schedule: $schedule) {
          id
          day0
          day1
          day2
          day3
          day4
          day5
          day6
          deliveryDate
          deliveryTime
          endAfterXTimes
          endOn
          endOnType
          isRepeated
          dateTimes
          minutesToAutoRetryRequest
          minutesBeforeCustomReminder
          completedAt
          canceledAt
        }
      }
    `),
  });

  return response.data?.updateSchedule;
};
